module.exports = __webpack_public_path__ + "static/front/img/instagram5.7a0554dc.jpg";